import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { SingleSizeIllustrationHeroOfferProduct } from '@xing-com/illustrations';
import { mediaWideNavless } from '@xing-com/layout-tokens';
import {
  spaceL,
  spaceXL,
  spaceXXL,
  space3XL,
  space4XL,
  space5XL,
  scale170,
  scale180,
  cornerRadiusL,
} from '@xing-com/tokens';
import { Headline, BodyCopy } from '@xing-com/typography';

export const StyledSection = styled.section`
  margin-bottom: ${space4XL};
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: ${spaceXXL};

  @media ${mediaWideNavless} {
    margin-bottom: ${scale170};
  }
`;

export const StyledIllustrationWrapper = styled.div`
  @media ${mediaWideNavless} {
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
`;

export const StyledIllustration = styled(
  SingleSizeIllustrationHeroOfferProduct
)`
  max-width: 100%;
  height: auto;
  flex-shrink: 0;
  display: none;
  margin-left: ${space5XL};

  @media ${mediaWideNavless} {
    display: block;
  }
`;

export const StyledTemplateWrapper = styled.div<{ $color: string }>`
  padding: ${spaceXL};
  background-color: ${({ $color }) => $color};
  margin-bottom: ${space3XL};
  border-radius: ${cornerRadiusL};

  @media ${mediaWideNavless} {
    padding: ${spaceXL} ${scale180};
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

export const StyledTemplateImage = styled.img`
  margin-bottom: ${spaceL};
  flex-shrink: 0;

  @media ${mediaWideNavless} {
    margin-bottom: 0;
    margin-right: ${space3XL};
  }
`;

export const StyledButton = styled(Button)`
  margin-top: ${spaceL};

  @media ${mediaWideNavless} {
    margin-top: ${spaceXL};
  }
`;

export const StyledBodyCopy = styled(BodyCopy)`
  margin-bottom: ${space3XL};
`;
